import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { trackMetaEvent, getCheckoutUrlWithFbclid } from '../hooks/useMetaPixel';
const CHECKOUT_URL = 'https://dolaresenarg.shop/cart/45155071655983:1';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59
          };
        }
        return prev;
      });
    }, 60000); // Update every minute
    return () => clearInterval(timer);
  }, []);
  return <section className="py-20 px-4 bg-gradient-to-br from-[#00d4ff]/10 to-[#ff006e]/5 border-t border-[#00d4ff]/20" data-id="element-30">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-31">
        <h2 className="text-3xl md:text-[2.5rem] font-bold text-[#00d4ff] mb-8 uppercase" data-id="element-32">
          ÚLTIMO PASO
        </h2>

        <p className="text-lg md:text-[1.2rem] text-[#e0e0e0] mb-10 leading-relaxed" data-id="element-33">
          Decidir si sigues buscando en YouTube cursos gratis que no funcionan,
          o inviertes $14.990 ARS una sola vez y accedés al sistema que generó
          $270.000.000 ARS.
        </p>

        <a href={getCheckoutUrlWithFbclid(CHECKOUT_URL)} onClick={() => trackMetaEvent('InitiateCheckout')} className="inline-flex items-center justify-center gap-3 w-full max-w-[500px] bg-gradient-cyan-magenta text-[#1a1a2e] font-black text-xl uppercase tracking-[1px] py-5 px-8 rounded-lg shadow-[0_10px_40px_rgba(0,212,255,0.3)] hover:shadow-[0_20px_60px_rgba(0,212,255,0.5)] hover:-translate-y-[3px] transition-all duration-300 mb-8" data-id="element-34">
          SÍ, QUIERO ACCESO AHORA A $14.990 ARS ✓
        </a>

        <p className="text-[0.9rem] text-[#888] font-medium" data-id="element-35">
          La oferta se cierra en {timeLeft.hours}h {timeLeft.minutes}m. Después
          vuelve a <span className="text-red-500" data-id="element-36">$340.000 ARS</span>.
        </p>
      </div>
    </section>;
}